import type { PhotoCarGuide } from "./carGuideTypes";

const BASE = "/assets/car_exterior_guides";

/** Guided exterior shots 1–8; further photos are optional angles.
 *  Engine video is a separate session opened from the motor-video button. */
export const EXTERIOR_GUIDED_COUNT = 8;

/** Standalone engine-video guide — not part of the exterior photo walkthrough. */
export const ENGINE_VIDEO_GUIDE: PhotoCarGuide = {
  id: "engine",
  imageSrc: `${BASE}/engine.png`,
  labelKey: "engine",
  widthPct: 78,
  maxHeightPct: 64,
  scale: 0.92,
  captureMode: "video",
  maxVideoSeconds: 10,
};

export const EXTERIOR_CAR_GUIDES: PhotoCarGuide[] = [
  {
    id: "front",
    imageSrc: `${BASE}/front.png`,
    labelKey: "front",
    scale: 1.22,
  },
  {
    id: "front_left",
    imageSrc: `${BASE}/front_left.png`,
    labelKey: "frontLeft",
  },
  {
    id: "side_left",
    imageSrc: `${BASE}/side_left.png`,
    labelKey: "left",
  },
  {
    id: "back_left",
    imageSrc: `${BASE}/back_left.png`,
    labelKey: "backLeft",
  },
  {
    id: "back",
    imageSrc: `${BASE}/back.png`,
    labelKey: "back",
    scale: 1.22,
  },
  {
    id: "back_right",
    imageSrc: `${BASE}/back_right.png`,
    labelKey: "backRight",
  },
  {
    id: "side_right",
    imageSrc: `${BASE}/side_right.png`,
    labelKey: "right",
  },
  {
    id: "front_right",
    imageSrc: `${BASE}/front_right.png`,
    labelKey: "frontRight",
  },
];

export function getExteriorGuideForPhotoIndex(
  photoIndex: number,
): PhotoCarGuide | null {
  if (photoIndex < 1 || photoIndex > EXTERIOR_GUIDED_COUNT) return null;
  return EXTERIOR_CAR_GUIDES[photoIndex - 1] ?? null;
}
